// extracted by mini-css-extract-plugin
module.exports = {"root":"NewsList-module--root--3yoFk","newsWrapper":"NewsList-module--newsWrapper--2pxMC","ad":"NewsList-module--ad--__f-6","adLink":"NewsList-module--adLink--162nv"};